var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-4 pt-3"},[_c('a',{attrs:{"href":_vm.link_url}},[_c('img',{staticClass:"corner-logo",attrs:{"src":_vm.logo_url,"alt":_vm.$route.params.organization_name}})])])}
var staticRenderFns = []

export { render, staticRenderFns }